import {
  FETCH_FRANCHISES,
  FETCH_FRANCHISES_SUCCESS,
  FETCH_FRANCHISES_FAILED,
  EDIT_FRANCHISE,
  EDIT_FRANCHISE_SUCCESS,
  EDIT_FRANCHISE_FAILED,
  ADD_FRANCHISE,
  ADD_FRANCHISE_SUCCESS,
  ADD_FRANCHISE_FAILED,
  DELETE_FRANCHISE,
  DELETE_FRANCHISE_SUCCESS,
  DELETE_FRANCHISE_FAILED,
  GET_FRANCHISE,
  GET_FRANCHISE_SUCCESS,
  GET_FRANCHISE_FAILED,
} from "../store/types";

const INITIAL_STATE = {
  franchises: [],
  loading: false,
  error: {
    flag: false,
    msg: null,
  },
};

export const franchisereducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_FRANCHISES:
      return {
        ...state,
        loading: true,
        error: { flag: false, msg: null },
      };
    case FETCH_FRANCHISES_SUCCESS:
      return {
        ...state,
        loading: false,
        franchises: action.payload,
        error: { flag: false, msg: null },
      };
    case FETCH_FRANCHISES_FAILED:
      return {
        ...state,
        loading: false,
        error: { flag: true, msg: action.payload },
      };
    case EDIT_FRANCHISE:
      return {
        ...state,
        loading: true,
      };
    case EDIT_FRANCHISE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {
          flag: false,
          msg: null,
        },
      };
    case EDIT_FRANCHISE_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };
    case ADD_FRANCHISE:
      return {
        ...state,
        loading: true,
      };
    case ADD_FRANCHISE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {
          flag: false,
          msg: null,
        },
      };
    case ADD_FRANCHISE_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };
    case DELETE_FRANCHISE:
      return {
        ...state,
        loading: true,
      };
    case DELETE_FRANCHISE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {
          flag: false,
          msg: null,
        },
      };
    case DELETE_FRANCHISE_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };
    case GET_FRANCHISE:
      return {
        ...state,
        loading: true,
      };
    case GET_FRANCHISE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {
          flag: false,
          msg: null,
        },
      };
    case GET_FRANCHISE_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };
    default:
      return state;
  }
};
